type WhatsAppOutlineIconProps = {
  className?: string;
  width?: string | number;
  height?: string | number;
};

export const WhatsAppOutlineIcon = (props: WhatsAppOutlineIconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.5 9.58336C17.5029 10.6832 17.2459 11.7683 16.75 12.75C16.162 13.9265 15.2581 14.916 14.1395 15.6078C13.021 16.2995 11.7319 16.6662 10.4167 16.6667C9.31678 16.6696 8.23176 16.4126 7.25 15.9167L2.5 17.5L4.08333 12.75C3.58744 11.7683 3.33047 10.6832 3.33333 9.58336C3.33384 8.26815 3.70051 6.97907 4.39227 5.86048C5.08402 4.7419 6.07355 3.838 7.25 3.25002C8.23176 2.75413 9.31678 2.49716 10.4167 2.50002H10.8333C12.5703 2.59585 14.2109 3.32899 15.4409 4.55907C16.671 5.78915 17.4042 7.42973 17.5 9.16669V9.58336Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.8325 11.6399V12.6399C13.8329 12.7327 13.8139 12.8246 13.7767 12.9097C13.7395 12.9947 13.6849 13.0711 13.6165 13.1338C13.5481 13.1966 13.4674 13.2444 13.3794 13.2741C13.2915 13.3038 13.1983 13.3149 13.1058 13.3065C12.0801 13.1951 11.0948 12.8446 10.2292 12.2832C9.42377 11.7714 8.74094 11.0886 8.22916 10.2832C7.66582 9.4136 7.31524 8.42353 7.20583 7.3932C7.1975 7.30103 7.20846 7.20812 7.238 7.12041C7.26754 7.0327 7.31502 6.9521 7.37742 6.88374C7.43982 6.81539 7.51577 6.76077 7.60043 6.72338C7.68509 6.68598 7.77661 6.66662 7.86916 6.66654H8.86916C9.03093 6.66494 9.18776 6.72223 9.31042 6.82771C9.43307 6.9332 9.51319 7.07969 9.53583 7.23987C9.57804 7.55989 9.65631 7.87411 9.76916 8.17654C9.81401 8.29584 9.82372 8.42551 9.79713 8.55016C9.77055 8.67482 9.70878 8.78924 9.61916 8.87987L9.19583 9.3032C9.67035 10.1377 10.3613 10.8287 11.1958 11.3032L11.6192 10.8799C11.7098 10.7902 11.8242 10.7285 11.9489 10.7019C12.0735 10.6753 12.2032 10.685 12.3225 10.7299C12.6249 10.8427 12.9391 10.921 13.2592 10.9632C13.4211 10.986 13.569 11.0676 13.6747 11.1924C13.7804 11.3171 13.8366 11.4764 13.8325 11.6399Z"
      fill="#5F5F5F"
    />
  </svg>
);
